import React from 'react';
import { FormattedMessage } from 'react-intl';

// Checkerboard pattern to mimic a placeholder image (transparent squares)
const CheckerboardImage = ({ height = 160 }) => (
    <svg width="100%" height={height} xmlns="http://www.w3.org/2000/svg">
        <defs>
            <pattern id="checker" width="16" height="16" patternUnits="userSpaceOnUse">
                <rect width="8" height="8" fill="#d1d5db" />
                <rect x="8" width="8" height="8" fill="#e5e7eb" />
                <rect y="8" width="8" height="8" fill="#e5e7eb" />
                <rect x="8" y="8" width="8" height="8" fill="#d1d5db" />
            </pattern>
        </defs>
        <rect width="100%" height={height} fill="url(#checker)" />
    </svg>
);

const WidgetPreview = ({ colors, font, themeMode }) => {
    const isDark  = themeMode === 'dark';

    // colours derived from the widget's own CSS variable system
    const bg       = isDark ? '#191a1a' : '#f3f3f3';
    const cardBg   = isDark ? '#2a2b2b' : '#fbfdfe';
    const border   = isDark ? '1px solid #3f4040' : '1px solid #cfd0d0';
    const textMuted = isDark ? '#b4b5b5' : '#6b6e6e';
    const shadow   = isDark ? '0 2px 12px rgba(0,0,0,0.5)' : '0 2px 12px rgba(0,0,0,0.1)';
    const f        = font || 'inherit';

    return (
        <div style={{ backgroundColor: bg, borderRadius: '12px', padding: '20px', fontFamily: f, display: 'flex', justifyContent: 'center' }}>

            {/* Card */}
            <div style={{
                backgroundColor: cardBg,
                borderRadius: '12px',
                border,
                boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
                overflow: 'hidden',
                width: '100%',
                maxWidth: '320px',
                fontFamily: f,
            }}>

                {/* Image area */}
                <div style={{ position: 'relative' }}>
                    <CheckerboardImage height={160} />

                    {/* Discount badge */}
                    <div style={{
                        position: 'absolute',
                        top: '10px',
                        left: '10px',
                        backgroundColor: colors.accent,
                        color: '#fff',
                        fontWeight: '700',
                        fontSize: '0.78rem',
                        padding: '4px 10px',
                        borderRadius: '6px',
                        fontFamily: f,
                    }}>
                        -20%
                    </div>
                </div>

                {/* Body */}
                <div style={{ padding: '14px 16px 16px', color: colors.text }}>

                    {/* Tag / category */}
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}>
                        <i className="fa-solid fa-tag mr-1" style={{ color: colors.primary, fontSize: '0.72rem' }} />
                        <span style={{ color: colors.primary, fontSize: '0.78rem', fontWeight: '600', fontFamily: f }}>Wellness</span>
                    </div>

                    {/* Title */}
                    <div style={{ fontWeight: '700', fontSize: '1rem', marginBottom: '6px', fontFamily: f, color: colors.text }}>
                        <FormattedMessage id="WidgetConfig.CardTitle" />
                    </div>

                    {/* Description */}
                    <div style={{ fontSize: '0.8rem', color: textMuted, marginBottom: '12px', lineHeight: '1.45', fontFamily: f }}>
                        <FormattedMessage id="WidgetConfig.CardDesc" />
                    </div>

                    {/* Price row */}
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px', marginBottom: '14px' }}>
                        <span style={{ fontWeight: '700', fontSize: '1.25rem', color: colors.primary, fontFamily: f }}>100,00 €</span>
                        <span style={{ fontSize: '0.82rem', color: textMuted, textDecoration: 'line-through', fontFamily: f }}>120,00 €</span>
                    </div>

                    {/* Action buttons */}
                    <div style={{ display: 'flex', gap: '8px' }}>
                        {/* Info button */}
                        <button style={{
                            width: '40px',
                            height: '40px',
                            flexShrink: 0,
                            border,
                            borderRadius: '8px',
                            backgroundColor: 'transparent',
                            cursor: 'default',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: textMuted,
                        }}>
                            <i className="fa-solid fa-circle-info" style={{ fontSize: '1rem' }} />
                        </button>

                        {/* Add to cart */}
                        <button style={{
                            flex: 1,
                            height: '40px',
                            backgroundColor: colors.primary,
                            color: '#fff',
                            border: 'none',
                            borderRadius: '8px',
                            fontWeight: '600',
                            fontSize: '0.85rem',
                            cursor: 'default',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '7px',
                            fontFamily: f,
                        }}>
                            <i className="fa-solid fa-cart-shopping" />
                            <FormattedMessage id="WidgetConfig.Buy" />
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default WidgetPreview;